import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
/**
 * ReceiptBannerCaption
 */
export const receiptBannerCaptionStyles = () => css `
	margin: 0;
`;
export const StyledReceiptBannerCaption = styled(Typography).attrs({
    variant: 'body-text-xs',
    tagName: 'p',
}) `
	${receiptBannerCaptionStyles}
`;
